import { Option, Select } from "_/components/select";

export interface FilterSelectProps {
  name: string;
  options: Option<string>[];
  placeholder: string;
  filterValue: string;
  onFilterChange: (value: string) => void;
}

/**
 * A searchable filter Select that keeps its typed text as the filter value,
 * and selects all text when focused for easy replacement.
 */
export function FilterSelect({
  name,
  options,
  placeholder,
  filterValue,
  onFilterChange,
}: FilterSelectProps) {
  return (
    <Select
      name={name}
      options={options}
      isSearchable={true}
      placeholder={placeholder}
      neverHideInput={true}
      isClearable={true}
      isOptionSelected={(option: Option<string>) =>
        option.data?.toLowerCase() === filterValue.toLowerCase()
      }
      inputValue={filterValue}
      onInputChange={(value: string, { action }: { action: string }) => {
        if (action === "input-change") {
          onFilterChange(value);
        }
      }}
      onChange={(value: string | null) => {
        onFilterChange(value ?? "");
      }}
      onFocus={(e: React.FocusEvent<HTMLInputElement>) => {
        setTimeout(() => e.target.select(), 0);
      }}
    />
  );
}
